import React, { useEffect, useState } from 'react';
import Button from '../../components/Button/Button';
import Input from '../../components/Input/Input';
import Modal from '../../components/Modal/Modal';
import './donotcalllist.scss';
import { ReactComponent as CloseIcon } from '../../images/Close.svg';
import { useNavigate, useParams } from 'react-router-dom';
import base from '../../apis';
import Spinner from '../../components/Spinner/Spinner';
import { toast } from 'react-toastify';
import { getCallStatus } from '../../utils/functions';
import { useRef } from 'react';
import { useSelector } from 'react-redux';

function DoNotCallList() {
  const { status } = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [detailsModalOpen, setDetailsModalOpen] = React.useState(false);
  const [list, setList] = useState([]);
  useEffect(() => {
    const allowed = ['not-interested', 'do-not-call', 'did-not-answer'];
    if (!allowed.includes(status)) {
      navigate('/404');
    }
  }, [navigate, status]);

  const marketing_team_id = useSelector((state) => state.auth.marketerDetails.team_id);

  const ORIGINAL_TASKS = useRef([]);
  useEffect(() => {
    if (!marketing_team_id) {
      toast.error('You have not been assigned to a team. Please contact the administrator.', { toastId: 'noteam' });
      return;
    }
    let call_status = '';
    if (status === 'not-interested') call_status = 'NI';
    else if (status === 'do-not-call') call_status = 'DC';
    else call_status = 'NA';
    const url = `/operations/marketing_teams/${marketing_team_id}/tasks/?call_status=${call_status}`;

    setIsLoading(true);
    setList([]);
    setSearchParams({
      agent_name: '',
      office_name: '',
      office_address: '',
    });
    base
      .get(url)
      .then(({ data }) => {
        if (data.length === 0) {
          toast.warn('No records found');
        }
        setList(data);
        ORIGINAL_TASKS.current = data;
      })
      .catch((err) => {
        toast.error(`Error loading ${status.split('-').join(' ')} calls`);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [marketing_team_id, status]);

  const [selectedTask, setSelectedTask] = useState(null);
  const onSelectTask = (task) => {
    setDetailsModalOpen(true);
    setSelectedTask(task);
  };
  const [searchParams, setSearchParams] = useState({
    agent_name: '',
    office_name: '',
    office_address: '',
  });

  const onChangeSearchParams = (e) => {
    const { name, value } = e.target;
    setSearchParams({
      ...searchParams,
      [name]: value,
    });
  };

  const onSearch = (e) => {
    e.preventDefault();
    let filtered = [];
    if (searchParams.agent_name === '' && searchParams.office_name === '' && searchParams.office_address === '') {
      filtered = ORIGINAL_TASKS.current;
    } else {
      filtered = ORIGINAL_TASKS.current.filter((task) => {
        return (
          `${task.agent_first_name}${task.agent_last_name}`
            .toLowerCase()
            .includes(searchParams.agent_name.toLowerCase()) &&
          task.office.branch.toLowerCase().includes(searchParams.office_name.toLowerCase()) &&
          task.office.address.toLowerCase().includes(searchParams.office_address.toLowerCase())
        );
      });
    }
    setList(filtered);
  };

  return (
    <>
      {isLoading && <Spinner />}
      <Modal open={detailsModalOpen} onClose={() => setDetailsModalOpen(false)}>
        <div className="mod2" style={{ minWidth: '70vw' }}>
          <div className="mod2header">
            <div>
              <p>{selectedTask?.office.branch}</p>
              <p>{selectedTask?.office.address}</p>
            </div>
            <CloseIcon
              onClick={() => setDetailsModalOpen(false)}
              style={{ fill: '#1378A5', cursor: 'pointer' }}
              width="18px"
              height="18px"
            />{' '}
          </div>
          <div className="contholder">
            <div>
              <p>
                Agent's Name:{' '}
                <span className="big">
                  {selectedTask?.agent_first_name} {selectedTask?.agent_last_name}
                </span>
              </p>
              <p>
                Agent's Number: <span className="big">{selectedTask?.agent_phone}</span>
              </p>
              <p>
                Agent's Email: <span className="big">{selectedTask?.agent_email}</span>
              </p>
            </div>
            <div>
              <p>
                Latest Call:{' '}
                <span className="big">
                  {new Date(selectedTask?.last_call).toLocaleString('en', {
                    weekday: 'long',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                    month: 'short',
                    year: 'numeric',
                  })}
                </span>
              </p>
              <p>
                Status of call:{' '}
                <span className="big" style={{ color: 'var(--primary-color)' }}>
                  {' '}
                  {getCallStatus(selectedTask?.call_status)}
                </span>
              </p>
              <p style={{ color: 'var(--primary-color)' }}>
                Current Marketing Executive:{' '}
                <span className="big">
                  {selectedTask?.marketer.user.first_name} {selectedTask?.marketer.user.last_name}
                </span>
              </p>
            </div>
          </div>
        </div>
      </Modal>
      <div className="dnclist">
        <form className="modinputs" onSubmit={(e) => e.preventDefault()}>
          <Input
            type="search"
            placeholder="Enter Agent Name"
            style={{ fontSize: '16px', padding: '10px 20px' }}
            fullStyles={{ flex: 1 }}
            name="agent_name"
            value={searchParams.agent_name}
            onChange={onChangeSearchParams}
          />
          <Input
            type="search"
            placeholder="Enter Office Name"
            style={{ fontSize: '16px', padding: '10px 20px' }}
            fullStyles={{ flex: 1 }}
            name="office_name"
            value={searchParams.office_name}
            onChange={onChangeSearchParams}
          />
          <Input
            type="search"
            placeholder="Enter Office Address"
            style={{ fontSize: '16px', padding: '10px 20px' }}
            fullStyles={{ flex: 1 }}
            name="office_address"
            value={searchParams.office_address}
            onChange={onChangeSearchParams}
          />
          <Button
            style={{
              width: '100px',
              fontSize: '16px',
              padding: '10px',
              color: 'white',
              backgroundColor: 'var(--primary-color)',
              display: 'block',
            }}
            type="submit"
            onClick={onSearch}
            text="Filter"
          />
        </form>
        <div className="dnclistcontent">
          {list.map((item) => (
            <SubscriberRow
              key={item.id}
              name={item.agent_first_name + ' ' + item.agent_last_name}
              address={item.office.branch}
              date={new Date(item.last_call).toLocaleString('en', { month: 'short', day: '2-digit', year: 'numeric' })}
              onClick={() => onSelectTask(item)}
            />
          ))}
        </div>
      </div>
    </>
  );
}

export default DoNotCallList;

function SubscriberRow({ name, address = 'Coldwell Banker -Santa Clara, CA', date = 'Feb 16th, 2022', onClick }) {
  return (
    <div className="checker" onClick={onClick}>
      <span className="cname">{name}</span>
      <span className="coffice" style={{ textAlign: 'left' }}>
        {address}
      </span>
      <span className="ccity">{date}</span>
    </div>
  );
}
